import React from 'react';
import DeliveryInstructions from 'src/components/enterprise/features/OrderHistory/OrderReceipt/FulfillmentInfo/DeliveryInstructions';
import { IFulfillmentInfoProps } from 'src/components/enterprise/features/OrderHistory/OrderReceipt/FulfillmentInfo/FulfillmentInfo';
import { HeadingAndValues } from 'src/components/enterprise/features/OrderHistory/OrderReceipt/HeadingAndValues';

export interface IDeliveryInfoProps extends IFulfillmentInfoProps {
  address: string;
  instructions: string;
}

export function DeliveryInfo({
  date,
  address,
  instructions,
}: IDeliveryInfoProps): JSX.Element {
  return (
    <>
      <HeadingAndValues heading="Delivery date" values={[date]} />
      <HeadingAndValues heading="Delivery address" values={[address]} />
      <DeliveryInstructions value={instructions} />
    </>
  );
}
